export const MOBILE_FORM_FACTOR = 'Mobile';
export const TABLET_FORM_FACTOR = 'Tablet';
export const DESKTOP_FORM_FACTOR = 'Desktop';
